export const ReportingRoute = {
  REPORTING: 'reporting',
  FINANCIAL_INSIGHTS: {
    name: 'financial-insights',
    path: 'financial-insights'
  },
  CUSTOM_REPORTS: {
    name: 'custom-reports',
    path: 'custom-reports'
  }
};
